import { render, staticRenderFns } from "./EFormArquivo.vue?vue&type=template&id=e878b83a"
import script from "./EFormArquivo.vue?vue&type=script&lang=js"
export * from "./EFormArquivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports